module.exports = __webpack_public_path__ + "img/streaming_moto.817adc83.svg";